<div class="dual-toggle-container" [class.fixed-width]="type() === 'text'">
  <div class="dual-toggle-selected-button-container-left">
    <button
      type="button"
      class="dual-toggle-button-base dual-toggle-left"
      [class.symbol]="type() === 'symbol'"
      [class.selected]="selected() === DualToggleState.left"
      (click)="selected() !== DualToggleState.left && toggleSelect.emit(DualToggleState.left)">
      @if (type() === 'symbol') {
        <mat-icon [style.color]="'inherit'" [svgIcon]="left()"></mat-icon>
      }
      @if (type() === 'text' || type() === 'compact-text') {
        <div class="dual-toggle-button-title" [class.fixed-width]="type() === 'text'">
          {{ left() }}
        </div>
      }
    </button>
  </div>
  <div class="dual-toggle-selected-button-container-right">
    <button
      type="button"
      class="dual-toggle-button-base dual-toggle-right"
      [class.symbol]="type() === 'symbol'"
      [class.selected]="selected() === DualToggleState.right"
      (click)="selected() !== DualToggleState.right && toggleSelect.emit(DualToggleState.right)">
      @if (type() === 'symbol') {
        <mat-icon [style.color]="'inherit'" [svgIcon]="right()"></mat-icon>
      }
      @if (type() === 'text' || type() === 'compact-text') {
        <div class="dual-toggle-button-title" [class.fixed-width]="type() === 'text'">
          {{ right() }}
        </div>
      }
    </button>
  </div>
</div>
